import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from 'material-ui/Tabs'
import IconButton from 'material-ui/IconButton'
import { GridList, GridTile } from 'material-ui/GridList'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import OpenInNew from 'material-ui/svg-icons/action/open-in-new'
import FileFolderOpen from 'material-ui/svg-icons/content/archive'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import { instance } from '../../lib/api'
import {
  LOAD_COUNT_INCREMENT,
  LOAD_COUNT_DECREMENT,
  SHOW_SNACKBAR_TOASTR
} from '../../actions/loading'

export default class Documents extends Component {
  static propTypes = {
    documents: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      value: 1,
      fileId: null,
      showConfirm: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.deleteImage = this.deleteImage.bind(this)
    this.deleteImageRequest = this.deleteImageRequest.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleChange = value => {
    this.setState({
      value
    })
  }

  deleteImageRequest(fileId) {
    this.setState({
      fileId,
      showConfirm: true
    })
  }

  deleteImage() {
    const url = `/mystique/rcm/v1/image/delete-images?fileIds=${this.state.fileId}`
    this.props.dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Deleting Image'
    })
    instance({
      url,
      method: 'delete'
    })
      .then(() => {
        this.props.onDeleteSuccess()
        this.props.dispatch({
          type: LOAD_COUNT_DECREMENT
        })
        this.props.dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message: 'Image deleted successfuly.'
        })
      })
      .catch(err => {
        this.props.dispatch({
          type: LOAD_COUNT_DECREMENT
        })
        this.props.dispatch({
          type: SHOW_SNACKBAR_TOASTR,
          message: 'Some error occured.'
        })
      })
    this.handleClose()
  }

  handleClose() {
    this.setState({
      fileId: null,
      showConfirm: false
    })
  }

  render() {
    const documents = this.props.documents
    let tabCount = 1
    const actions = [
      <FlatButton label='Delete' primary onClick={this.deleteImage} />,
      <FlatButton label='Cancel' primary onClick={this.handleClose} />
    ]
    return (
      <div>
        <Tabs value={this.state.value} onChange={this.handleChange}>
          {Object.keys(documents).map(type => (
            <Tab label={type} value={tabCount++} key={type}>
              <Gallery
                tilesData={documents[type]}
                tabCount={tabCount - 1}
                deleteImageRequest={this.deleteImageRequest}
              />
            </Tab>
          ))}
        </Tabs>
        <Dialog
          actions={actions}
          modal={false}
          open={this.state.showConfirm}
          onRequestClose={this.handleClose}
        >
          Are you sure, you want to delete this?
        </Dialog>
      </div>
    )
  }
}

class Gallery extends Component {
  static propTypes = {
    tilesData: PropTypes.array
  }

  deleteImage(fileId) {
    this.props.deleteImageRequest(fileId)
  }

  openImage = imageUrl => {
    var win = window.open(imageUrl, '_blank')
    if (win) {
      // Browser has allowed it to be opened
      win.focus()
    } else {
      // Browser has blocked it
      alert('Please allow popups for this website')
    }
  }

  render() {
    const styles = {
      root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
      },
      gridList: {
        width: 500,
        height: 350,
        overflowY: 'auto'
      },
      titleStyle: {
        color: 'rgb(0, 188, 212)'
      }
    }

    const tilesData = this.props.tilesData
    let imageCount = 1
    return (
      <div style={styles.root}>
        <GridList style={styles.gridList} cols={2.2}>
          {tilesData.map((tile, index) => {
            const extension = tile.url.split('.').pop(),
              isImage = ['png', 'jpg', 'jpeg', 'gif'].includes(extension)
            return (
              <React.Fragment>
                <GridTile
                  key={imageCount++}
                  title={`#${index + 1}`}
                  actionIcon={
                    <IconButton onClick={this.openImage.bind(this, tile.url)}>
                      <OpenInNew color='rgb(0, 188, 212)' />
                    </IconButton>
                  }
                  titleStyle={styles.titleStyle}
                  titleBackground='linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)'
                >
                  {isImage ? (
                    <img role='presentation' src={tile.url} />
                  ) : (
                    <FileFolderOpen
                      style={{
                        width: '180px',
                        height: '180px',
                        color: 'rgb(0, 188, 212)'
                      }}
                    />
                  )}
                </GridTile>
                <p>{tile.createdAt}</p>
              </React.Fragment>
            )
          })}
        </GridList>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Documents/Documents.js
 **/